var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueRecaptcha',{ref:"recaptcha",staticClass:"recaptcha",attrs:{"sitekey":"6LfnIJkUAAAAANhHtvztAzCSiukBNsZw4VqEb8-0"},on:{"verify":function($event){return _vm.$emit('verify')}}})}
var staticRenderFns = []

export { render, staticRenderFns }